import React from 'react';

import { Bed } from '@travel/icons/service';
import { useDeviceType, MOBILE_SCREEN } from '@travel/traveler-core/hooks';
import { ariaOnKeyDown } from '@travel/utils';

import { Translate } from 'core/translate';

import styles from './notFoundBox.module.scss';

type Props = {
  /** on click function more dates prompt */
  moreDateClick: () => void;
};

function NotFoundBox(props: Props) {
  const isMobile = useDeviceType() === MOBILE_SCREEN;

  const results = <Translate id="Provider_Info.Provider_Details.Results" className={styles.text} />;
  const prompt = (
    <span
      className={styles.linkText}
      onClick={props.moreDateClick}
      role="button"
      tabIndex={0}
      onKeyDown={ariaOnKeyDown(props.moreDateClick)}
      data-testid="notFoundBox-prompt-button"
    >
      <Translate id="Provider_Info.Provider_Details.Results.Prompt" />
    </span>
  );
  return (
    <div className={styles.notFoundBox} data-testid="noFoundBox-wrapper">
      <Bed size={isMobile ? 60 : 80} color={'pastelGray'} className={styles.bedIcon} />
      <div className={styles.centerContent}>
        {isMobile ? (
          <>
            <div>{results}</div>
            <div>{prompt}</div>
          </>
        ) : (
          <>
            {results}
            &nbsp;
            {prompt}
          </>
        )}
      </div>
    </div>
  );
}

export default NotFoundBox;
